import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Pages from './Pages';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Pages />
  </React.StrictMode>
);
